import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HomeService from "../Services/Home";
import DefaultBook from "../Images/defaultBook.png";
import { Breadcrumbs } from "./E-BooksComponent";
import Loader from "./Loader";
import "../Styles/MagazineLanding.css";

const formatLatestIssue = (issue?: {
  editionNo?: number;
  month?: number;
  year?: string;
}) => {
  if (!issue) return "—";
  const { editionNo, month, year } = issue;
  if (editionNo == null || month == null || year == null || year === "") return "—";
  return `EditionNo.${editionNo} ${month}-${year}`;
};

const ArrowRightIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const MagazineLandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [magazines, setMagazines] = useState<any[] | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    HomeService.getmagzine(0, 10)
      .then((res) => {
        if (res?.status && res?.result?.items) {
          setMagazines(res.result.items);
        }
      })
      .catch((err) => {
        console.error("Error fetching magazines:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleCardClick = (productId: number, lang?: string) => {
    const normalizedLang = lang?.trim() ?? "";
    switch (productId) {
      case 5:
        navigate(`/kalyan`);
        break;
      case 6:
        navigate(`/kalyanakalpataru`);
        break;
      case 7:
        navigate(`/geetgovind`, { state: { language: normalizedLang } });
        break;
      case 8:
        navigate(`/vivekvani`);
        break;
      default:
        navigate(`/books`);
        break;
    }
  };

  return (
    <>
      <Breadcrumbs
        mainsubBreadCrumb={t("magazine_tr")}
        subBreadCrumb={t("Home_tr")}
        navigatemainsubBreadCrumb={() => navigate("/home")}
        subBreadCrumbTwo={t("magazine_tr")}
        navigatesubBreadCrumb={() => {}}
      />

      <div className="magazine-landing-section">
        <div className="containers">
          {loading ? (
            <div style={{ minHeight: "300px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Loader loading={loading} />
            </div>
          ) : (
            <>
              <div className="magazine-header">
                {/* <span className="magazine-subtitle">— {t("Explore_Categories_tr", "EXPLORE CATEGORIES")} —</span>
                <h1 className="magazine-title">
                  {magazines ? magazines.length : 6} {t("Categories_Endless_Stories_tr", "Categories. Endless Stories.")}
                </h1>
                <p className="magazine-desc">
                  {t(
                    "Discover_Magazines_Desc_tr",
                    "Discover magazines that inspire, inform and entertain across every aspect of life."
                  )}
                </p> */}
              </div>

              {magazines && magazines.length > 0 ? (
                <div className="magazine-grid">
                  {magazines.map((item, index) => {
                    // Alternating Gradient Classes: gradient-a (even), gradient-b (odd)
                    const gradientClass = index % 2 === 0 ? "gradient-a" : "gradient-b";

                    // Localize language label if possible
                    const langLabel = item.magazineLangauge 
                      ? item.magazineLangauge.charAt(0).toUpperCase() + item.magazineLangauge.slice(1)
                      : "Hindi";

                    // Prefer the API-provided magazineTotal; fall back to common alternatives
                    const totalIssues = Number(
                      item.magazineTotal ?? item.total ?? item.totalIssues ?? item.magazineTotalCount ?? 0
                    );

                    return (
                      <div
                        key={item.id || index}
                        className={`magazine-card ${gradientClass}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleCardClick(item.productId, item.magazineLangauge)}
                      >
                        <div className="magazine-card-left">
                          <img
                            className="magazine-book-cover"
                            src={item.coverPagePath || item.coverPageThumbPath || DefaultBook}
                            onError={(e) => {
                              e.currentTarget.src = DefaultBook;
                            }}
                            alt={item.name}
                            title={item.name}
                          />
                        </div>

                        <div className="magazine-card-right">
                          <div>
                            <h2 className="magazine-card-title">
                              {item.name || t("magazine_tr")}
                            </h2>

                            <p className="magazine-card-meta">
                              <strong>{totalIssues}</strong> {t("Issues_tr", "Issues")}
                            </p>

                            <div className="magazine-card-meta magazine-card-latest-issue">
                              <span>{t("Latest_Issue_tr", "Latest issue")}:</span>
                              <span className="magazine-card-latest-value">
                                {formatLatestIssue(item.latest_Issue)}
                              </span>
                            </div>

                            <p className="magazine-card-meta">
                              {t("Language_tr", "Language")}: {langLabel}
                            </p>
                          </div>

                          <button
                            className="magazine-collection-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCardClick(item.productId, item.magazineLangauge);
                            }}
                          >
                            {t("magazine_view_all_tr")} <ArrowRightIcon />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "40px", fontSize: "20px", color: "#3f220d" }}>
                  {t("result_not_found_tr")}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MagazineLandingPage;
